import axios from 'utils/axios';
import { formateDateYYYMMDD } from 'utils/func';

const url = 'transaction/pethotel';

export const getTransactionPetHotelStats = async () => {
  return await axios.get(`${url}/stats`);
};

export const getTransactionPetHotelIndex = async (payload) => {
  return await axios.get(url, {
    params: {
      orderValue: payload.orderValue,
      orderColumn: payload.orderColumn,
      goToPage: payload.goToPage,
      rowPerPage: payload.rowPerPage,
      search: payload.search,
      locationId: payload.locationId,
      customerGroupId: payload.customerGroupId,
      status: payload.status, // ongoing or finished
      statusFilter: payload.statusFilter || '',
      startDateFrom: payload.startDateFrom || '',
      startDateTo: payload.startDateTo || ''
    }
  });
};

export const createTransactionPetHotel = async (payload) => {
  const { isNewPet, startDate, endDate, petDob, isNewCustomer, customer, location } = mapPayloadTransactionForm(payload);

  const formData = new FormData();
  formData.append('isNewCustomer', isNewCustomer ? 1 : 0);
  formData.append('locationId', location);
  formData.append('customerId', isNewCustomer ? '' : customer);
  formData.append('customerName', isNewCustomer ? customer : '');
  formData.append('registrant', payload.registrantName || '');

  formData.append('isNewPet', isNewPet ? 1 : 0); // 0 untuk No, 1 untuk Yes
  formData.append('petId', !isNewPet ? payload.pets.value : ''); // untuk pet lama, pet baru tidak perlu diisi
  formData.append('petName', payload.petName || '');
  formData.append('petCategory', payload.petCategory?.value || '');
  formData.append('condition', payload.petCondition);
  formData.append('petGender', payload.petGender);
  formData.append('isSterile', payload.petSterile);
  formData.append('birthDate', petDob);
  formData.append('month', payload.petMonth);
  formData.append('year', payload.petYear);
  formData.append('startDate', startDate);
  formData.append('endDate', endDate);
  formData.append('doctorId', payload.treatingDoctor?.value); // sementara hardcode dlu, ga dpt datanya
  formData.append('note', payload.notes);
  if (payload.image) formData.append('image', payload.image);
  if (payload.queueId) formData.append('queueId', payload.queueId);

  return await axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const getTransactionPetHotelDetail = async (payload) => {
  const dateFrom = payload.dateRange ? formateDateYYYMMDD(payload.dateRange[0]) : '';
  const dateTo = payload.dateRange ? formateDateYYYMMDD(payload.dateRange[1]) : '';

  return await axios.get(url + '/detail', {
    params: { id: payload.id, dateFrom, dateTo }
  });
};

export const transactionPetHotelTreatment = async (payload) => {
  const formData = new FormData();

  formData.append('transactionId', payload.transactionId);
  formData.append('serviceCategory', payload.serviceCategory);
  formData.append('treatmentPlans', JSON.stringify(payload.treatmentPlans));
  formData.append('services', JSON.stringify(payload.services));
  formData.append('productSells', JSON.stringify(payload.productSells));
  formData.append('productClinics', JSON.stringify(payload.productClinics));
  formData.append('cageId', payload.cage?.value);
  if (payload.stayServiceId) formData.append('stayServiceId', payload.stayServiceId);

  return await axios.post(url + '/treatment', formData);
};

export const updateTransactionPetHotel = async (payload) => {
  const { isNewPet, startDate, endDate, petDob, isNewCustomer, customer, location } = mapPayloadTransactionForm(payload);

  return await axios.put(url, {
    id: payload.id,
    registrationNo: payload.registrationNo,
    isNewCustomer: isNewCustomer,
    locationId: location,
    customerId: payload.customerId,
    customerName: customer,
    registrant: payload.registrantName || '',
    isNewPet, // 0 untuk No, 1 untuk Yes
    petId: payload.petId, // !isNewPet ? payload.pets.value : '' untuk pet lama, pet baru tidak perlu diisi
    petName: payload.petName || '',
    petCategory: payload.petCategory?.value || '',
    condition: payload.petCondition,
    petGender: payload.petGender,
    isSterile: payload.petSterile,
    birthDate: petDob,
    month: payload.petMonth,
    year: payload.petYear,
    startDate,
    endDate,
    doctorId: payload.treatingDoctor?.value, // sementara hardcode dlu, ga dpt datanya
    note: payload.notes
  });
};

export const deleteTransactionPetHotel = async (id) => {
  return await axios.delete(url, {
    data: { id }
  });
};

export const exportTransactionPetHotel = async (payload) => {
  return await axios.get(url + '/export', {
    responseType: 'blob',
    params: {
      locationId: payload?.locationId?.length ? payload.locationId : [''],
      customerGroupId: payload?.customerGroupId?.length ? payload.customerGroupId : ['']
    }
  });
};

export const reassignTransactionPetHotel = async (payload) => {
  const formData = new FormData();
  formData.append('transactionId', payload.transactionId);
  formData.append('doctorId', payload.doctorId);

  return await axios.post(url + '/reassign', formData);
};

export const acceptTransactionPetHotel = async (payload) => {
  const formData = new FormData();
  formData.append('transactionId', payload.transactionId);
  formData.append('status', payload.status);
  formData.append('reason', payload.reason);

  return await axios.post(url + '/accept', formData);
};

export const checkPetConditionTransactionPetHotel = async (payload) => {
  const estimateDateofBirth = payload.estimateDateofBirth ? formateDateYYYMMDD(new Date(payload.estimateDateofBirth)) : '';

  const formData = new FormData();
  formData.append('transactionId', payload.transactionId);
  formData.append('numberVaccines', payload.numberVaccines || 0);
  formData.append('isLiceFree', payload.isLiceFree ? 1 : 0);
  formData.append('noteLiceFree', payload.noteLiceFree);
  formData.append('isFungusFree', payload.isFungusFree ? 1 : 0);
  formData.append('noteFungusFree', payload.noteFungusFree);
  formData.append('isPregnant', payload.isPregnant ? 1 : 0);
  formData.append('estimateDateofBirth', estimateDateofBirth);

  formData.append('isRecomendInpatient', payload.isRecomendInpatient ? 1 : 0);
  formData.append('noteInpatient', payload.noteInpatient);

  formData.append('isParent', payload.isParent ? 1 : 0);
  formData.append('isBreastfeeding', payload.isBreastfeeding ? 1 : 0);
  formData.append('numberofChildren', payload.numberofChildren || 0);
  formData.append('isAcceptToProcess', payload.reasonReject ? 0 : 1);
  if (payload.reasonReject) formData.append('reasonReject', payload.reasonReject);

  return await axios.post(url + '/petcheck', formData);
};

const mapPayloadTransactionForm = (payload) => {
  const startDate = payload.startDate ? formateDateYYYMMDD(new Date(payload.startDate)) : '';
  const endDate = payload.endDate ? formateDateYYYMMDD(new Date(payload.endDate)) : '';
  const petDob = payload.petDateOfBirth ? formateDateYYYMMDD(new Date(payload.petDateOfBirth)) : '';

  const isNewCustomer = payload.customer !== 'old';
  const isNewPet = () => {
    if (payload.petId !== '') return false;
    if (isNewCustomer || payload.petName) return true;
    return false;
  };
  const customer = isNewCustomer ? payload.customerName : payload.customerName.value;
  const location = payload.location.value;

  return {
    isNewPet: isNewPet(),
    startDate,
    endDate,
    petDob,
    isNewCustomer,
    customer,
    location
  };
};

export const submitTransactionPetHotelDiscount = async (payload) => {
  const formData = new FormData();
  formData.append('transactionId', payload.transactionPetHotelId);

  payload.freeItems.forEach((freeItem) => {
    formData.append('freeItems[]', +freeItem);
  });
  payload.discounts.forEach((discount) => {
    formData.append('discounts[]', +discount);
  });
  payload.bundles.forEach((bundle) => {
    formData.append('bundles[]', +bundle);
  });
  formData.append('basedSale', +payload.basedSales);

  formData.append('recipes', JSON.stringify(payload.recipes));
  formData.append('services', JSON.stringify(payload.services));
  formData.append('products', JSON.stringify(payload.products));

  return await axios.post(url + '/discount', formData);
};

export const printInvoicePetHotelOutpatient = async (transactionId, formValue) => {
  const { detail_total, payment_method } = constructPayloadCreatePrintPetHotelOutpatient(formValue);

  return await axios.get(url + '/invoice', {
    responseType: 'blob',
    params: {
      transactionId: transactionId,
      purchases: JSON.stringify(formValue.summaryList),
      detail_total: JSON.stringify(detail_total),
      payment_method: JSON.stringify(payment_method)
    }
  });
};

export const checkPromoTransactionPetHotel = async (payload) => {
  const formData = new FormData();
  formData.append('transactionId', payload.transactionPetHotelId);
  formData.append('recipes', JSON.stringify(payload.recipes));
  formData.append('services', JSON.stringify(payload.services));
  formData.append('products', JSON.stringify(payload.products));

  return await axios.post(url + '/checkpromo', formData);
};

export const getBeforePayment = async (id) => {
  return await axios.get(url + '/beforepayment', {
    params: { transactionId: id }
  });
};

export const calculatePetHotelOutpatient = async (payload) => {
  const formData = new FormData();
  formData.append('transactionId', payload.transactionId);
  formData.append('services', JSON.stringify(payload.services ?? []));
  formData.append('products', JSON.stringify(payload.products ?? []));
  formData.append(
    'selectedPromos',
    JSON.stringify(
      payload.selectedPromos ?? {
        freeItems: [],
        discounts: [],
        bundles: [],
        basedSaleId: null
      }
    )
  );

  return await axios.post(url + '/calculate', formData);
};

export const getPaymentMethodsPetHotel = async () => {
  return await axios.get(url + '/payment-methods');
};

export const getPaymentHistoryPetHotel = async (transactionId) => {
  return await axios.get(url + '/payment/history', {
    params: { transactionId }
  });
};

export const printInvoicePetHotelOutpatientNew = async (transactionId) => {
  const formData = new FormData();
  formData.append('transactionId', transactionId);

  return await axios.post(url + '/invoice/outpatient', formData, {
    responseType: 'blob'
  });
};

const constructPayloadCreatePrintPetHotelOutpatient = (formValue) => {
  const detail_total = {
    subtotal: formValue.summarySubtotal,
    total_discount: formValue.summaryTotalDiscount,
    discount_based_sales: formValue.discountBasedSale,
    total_payment: formValue.summaryTotalPayment,
    promoBasedSaleId: formValue.promoBasedSaleId
  };

  const payment_method = {
    paymentMethodId: formValue.paymentMethodId,
    amount: undefined,
    amountPaid: undefined,
    duration: undefined,
    tenor: undefined,
    next_payment: undefined
  };

  if (formValue.paymentMethod === 'full') {
    payment_method.amountPaid = formValue.summaryTotalPayment;
  }

  if (formValue.paymentMethod === 'cicilan') {
    payment_method.amountPaid = formValue.installmentDp;
    payment_method.duration = formValue.installmentDuration;
    payment_method.tenor = formValue.installmentTenor;
  }

  if (formValue.paymentMethod === 'dp') {
    const next_payment = formValue.dpNextPayment ? formateDateYYYMMDD(new Date(formValue.dpNextPayment)) : '';
    payment_method.amountPaid = formValue.dpNominal;
    payment_method.next_payment = next_payment;
  }

  return { detail_total, payment_method };
};
export const createPaymentPetHotelOutpatient = async (transactionId, formValue) => {
  const { detail_total, payment_method } = constructPayloadCreatePrintPetHotelOutpatient(formValue);

  const formData = new FormData();
  formData.append('transactionId', transactionId);

  formData.append('purchases', JSON.stringify(formValue.summaryList));
  formData.append('detail_total', JSON.stringify(detail_total));
  formData.append('payment_method', JSON.stringify(payment_method));

  return await axios.post(url + '/payment', formData);
};

// Step 1: Staff upload bukti → status = 'pending'
export const uploadPaymentProofPetHotel = async (payload) => {
  const formData = new FormData();
  formData.append('id', payload.id);
  formData.append('proof', payload.file);
  return await axios.post(url + '/upload-payment-proof', formData);
};

// Step 2: Finance/Manager konfirmasi → 4-eyes check → status = 'verified'
export const confirmPaymentPetHotel = async (payload) => {
  const formData = new FormData();
  formData.append('id', payload.id);
  return await axios.post(url + '/confirm-payment', formData);
};

// Tolak bukti (Finance/Manager, orang berbeda dari yang upload)
export const rejectPaymentPetHotel = async (payload) => {
  return await axios.post(url + '/reject-payment', { id: payload.id, note: payload.note });
};

export const getPapanKerjaHarian = async (transactionId) => {
  return await axios.get(url + '/papan-kerja-harian', { params: { transactionId } });
};

export const markPapanKerjaHarianDone = async (payload) => {
  const formData = new FormData();
  formData.append('id', payload.id);
  formData.append('statusAktivitas', payload.statusAktivitas);
  (payload.temuan || []).forEach((t) => formData.append('temuan[]', t));
  formData.append('kondisiFeses', payload.kondisiFeses || '');
  formData.append('catatan', payload.catatan || '');
  if (payload.foto) formData.append('foto', payload.foto);
  return await axios.post(url + '/papan-kerja-harian/done', formData);
};

export const getPapanKerjaVetnurse = async (transactionId) => {
  return await axios.get(url + '/papan-kerja-vetnurse', { params: { transactionId } });
};

export const markPapanKerjaVetnurseDone = async (payload) => {
  const formData = new FormData();
  formData.append('id', payload.id);
  formData.append('statusAktivitas', payload.statusAktivitas);
  (payload.temuan || []).forEach((t) => formData.append('temuan[]', t));
  formData.append('kondisiFeses', payload.kondisiFeses || '');
  formData.append('catatan', payload.catatan || '');
  if (payload.foto) formData.append('foto', payload.foto);
  return await axios.post(url + '/papan-kerja-vetnurse/done', formData);
};

export const getAvailableItems = async (transactionId, type, search = '') => {
  return await axios.get(url + '/available-items', { params: { transactionId, type, search } });
};

export const getAdditionalTreatments = async (transactionId) => {
  return await axios.get(url + '/additional-treatment', { params: { transactionId } });
};

export const addAdditionalTreatment = async (payload) => {
  const formData = new FormData();
  formData.append('transactionId', payload.transactionId);
  formData.append('type', payload.type);
  formData.append('itemId', payload.itemId);
  formData.append('quantity', payload.quantity);
  formData.append('catatan', payload.catatan || '');
  return await axios.post(url + '/additional-treatment', formData);
};

export const deleteAdditionalTreatment = async (id) => {
  return await axios.delete(url + `/additional-treatment/${id}`);
};

export const extendStayPetHotel = async (payload) => {
  const formData = new FormData();
  formData.append('transactionId', payload.transactionId);
  formData.append('newEndDate', payload.newEndDate);
  return await axios.post(url + '/extend-stay', formData);
};

export const initiateCheckOut = async (payload) => {
  const formData = new FormData();
  formData.append('transactionId', payload.transactionId);
  if (payload.checkoutDate) formData.append('checkoutDate', payload.checkoutDate);
  return await axios.post(url + '/checkout/initiate', formData);
};

export const getCheckoutSummary = async (transactionId) => {
  return await axios.get(url + '/checkout/summary', { params: { transactionId } });
};

export const updateCheckoutDiscount = async (payload) => {
  return await axios.put(url + '/checkout/discount', {
    transactionId: payload.transactionId,
    discountAmount: payload.discountAmount,
    discountNote: payload.discountNote || ''
  });
};

export const getCheckoutInvoice = async (transactionId) => {
  return await axios.get(url + '/checkout/invoice', {
    params: { transactionId },
    responseType: 'blob'
  });
};

export const checkoutPayment = async (payload) => {
  const formData = new FormData();
  formData.append('transactionId', payload.transactionId);
  formData.append('paymentMethodId', payload.paymentMethodId);
  formData.append('amountPaid', payload.amountPaid);
  if (payload.note) formData.append('note', payload.note);
  if (payload.proof) formData.append('proof', payload.proof);
  return await axios.post(url + '/checkout/payment', formData);
};

export const getCheckCondition = async (transactionId) => {
  return await axios.get(url + '/check-condition', { params: { transactionId } });
};

export const getPoliciesForAgreement = async () => {
  return await axios.get(url + '/policies');
};

export const savePolicyAgreement = async (payload) => {
  const formData = new FormData();
  formData.append('transactionId', payload.transactionId);
  formData.append('signerName', payload.signerName);
  formData.append('signatureData', payload.signatureData);
  formData.append('policies', JSON.stringify(payload.policies));
  return await axios.post(url + '/policy-agreement', formData);
};

export const getPrepayments = async (transactionId) => {
  return await axios.get(url + '/prepayment', { params: { transactionId } });
};

export const getPrepaymentReceipt = async (prepaymentId) => {
  return await axios.get(url + `/prepayment/${prepaymentId}/receipt`, { responseType: 'blob' });
};

export const addPrepayment = async (payload) => {
  const formData = new FormData();
  formData.append('transactionId', payload.transactionId);
  formData.append('paymentMethodId', payload.paymentMethodId);
  formData.append('amount', payload.amount);
  formData.append('catatan', payload.catatan || '');
  if (payload.proof) formData.append('proof', payload.proof);
  return await axios.post(url + '/prepayment', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
